import { useQuery } from '@apollo/client'

import { GET_PATIENT_APPOINTMENT } from '../../../../operations/appointmentOperations'
import {
  getPatientAppointment,
  getPatientAppointmentVariables,
} from '../../../../models/graphqlTypes'
import { PatientAppointment } from '../types/patientEvents.types'

type ReturnData = {
  appointment?: PatientAppointment
  refetch: () => void
  loading: boolean
}

type Props = {
  appointmentId?: string
  skip?: boolean
}

// receive appointments for all or single treatment (used by patients)
export const usePatientAppointment = ({
  skip,
  appointmentId = '',
}: Props = {}): ReturnData => {
  const { data, loading, refetch } = useQuery<
    getPatientAppointment,
    getPatientAppointmentVariables
  >(GET_PATIENT_APPOINTMENT, {
    skip: skip || !appointmentId,
    variables: {
      appointmentId,
    },
  })

  return {
    appointment: data?.getAppointment,
    loading,
    refetch,
  }
}
